export default __webpack_public_path__ + "static/media/message_icon.8f0af19e.png";